<template>
  <div class="w-100 position-relative">
    <!-- Визуальная полоса прогресса.
         ВАЖНО: класс не должен называться progress-bar — это имя
         Bootstrap-компонента с transition: width .6s ease, из-за которого
         полоса анимируется и отстаёт от ползунка -->
    <!-- Ширина полосы повторяет траекторию центра ползунка:
         16px — ширина thumb, ползунок не выходит краями за трек -->
    <div
      class="range-fill"
      :style="`width: calc((100% - 16px) * ${modelValue / 100} + 8px)`"
    ></div>
    <input
      type="range"
      class="form-range w-100 custom-range"
      style="height: 4px"
      @input="handleRangeChange"
      @change="handleRangeCommit"
      @pointerdown="handleDragStart"
      @pointerup="handleDragEnd"
      @pointercancel="handleDragCancel"
      :value="modelValue"
      :min="min"
      :max="max"
      :step="step"
    />
  </div>
</template>

<script lang="ts">
import { Options, Vue, prop } from "vue-class-component";

class Props {
  modelValue = prop<number>({ required: true });
  min = prop<number>({ default: 0 });
  max = prop<number>({ default: 100 });
  step = prop<number>({ default: 1 });
}

@Options({
  components: {},
})
class BRange extends Vue.with(Props) {
  handleRangeChange(event: Event): void {
    const target = event.target as HTMLInputElement;
    if (!target) return;

    this.$emit("update:modelValue", Number(target.value));
    this.$emit("handleRangeChange", Number(target.value));
  }

  handleDragStart(): void {
    this.$emit("dragStart");
  }

  handleDragEnd(): void {
    this.$emit("dragEnd");
  }

  /**
   * Перетаскивание прервано (pointercancel): значение не подтверждено,
   * change не придёт — просто отпускаем слайдер
   */
  handleDragCancel(): void {
    this.$emit("dragEnd");
  }

  /**
   * Значение подтверждено: палец отпущен или сработала клавиатура.
   * Команды (перемотка и т.п.) надо слать сюда, а не в input —
   * иначе во время перетаскивания уходит шторм команд
   */
  handleRangeCommit(event: Event): void {
    const target = event.target as HTMLInputElement;
    if (!target) return;

    this.$emit("dragEnd", Number(target.value));
    this.$emit("rangeCommit", Number(target.value));
  }
}
export default BRange;
</script>

<style lang="scss" scoped>
@import "@/assets/sass/variables.scss";

.custom-range {
  position: relative;
  z-index: 0;
  background: transparent;
}

/* Переопределяем трек для WebKit браузеров */
.custom-range::-webkit-slider-runnable-track {
  background-color: rgba($white, 0.2) !important;
  border-radius: 4px;
  height: 6px;
}

/* Переопределяем трек для Firefox */
.custom-range::-moz-range-track {
  background-color: rgba($white, 0.2) !important;
  border-radius: 4px;
  height: 6px;
}

/* Переопределяем трек для IE/Edge */
.custom-range::-ms-track {
  background-color: rgba($white, 0.2) !important;
  border-radius: 4px;
  height: 6px;
  color: transparent;
}

/* Стили для ползунка (белый) */
.custom-range::-webkit-slider-thumb {
  background: $white !important;
  position: relative;
  z-index: 2;
  width: 16px;
  height: 16px;
  margin-top: -5px; /* центрируем thumb относительно трека 6px */
}

.custom-range::-moz-range-thumb {
  background: $white !important;
  position: relative;
  z-index: 2;
  width: 16px;
  height: 16px;
  margin-top: -5px; /* центрируем thumb относительно трека 6px */
}

.custom-range::-ms-thumb {
  background: $white !important;
  position: relative;
  z-index: 2;
}

.range-fill {
  position: absolute;
  top: calc(50% + 2px);
  left: 0;
  height: 6px;
  background: $white; /* цвет прогресса */
  pointer-events: none;
  z-index: 1;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  max-width: 100%;
  /* Без transition: полоса должна двигаться строго вместе с ползунком */
  transition: none;
}
</style>
